@if (label) {
  <label class="counter-label">{{ label }}</label>
}

<div class="counter-wrapper" [class.disabled]="disabled" [class.readonly]="readonly">
  <button
    type="button"
    class="counter-btn decrement"
    [disabled]="!canDecrement"
    (click)="decrement()"
    aria-label="Decrement">
    <lucide-icon name="minus"></lucide-icon>
  </button>

  <input
    type="number"
    class="counter-value"
    [value]="_value"
    [disabled]="disabled"
    [readonly]="readonly"
    [min]="min"
    [max]="max"
    (change)="onInputChange($event)"
    (blur)="onTouched()">

  <button
    type="button"
    class="counter-btn increment"
    [disabled]="!canIncrement"
    (click)="increment()"
    aria-label="Increment">
    <lucide-icon name="plus"></lucide-icon>
  </button>
</div>
